import ModuleNineReflection from "../../../../src/components/forms/ModuleNineReflection";
import * as React from 'react';
export default {
  ModuleNineReflection,
  React
};